import styled from 'styled-components'

import { font } from '~/styles/utils'

export const ProductSubtotal = styled.div`
  && {
    padding: 15px 0 0 0;
    margin-top: 5px;
    text-align: right;
    flex: 1;
    font-weight: 400;
    font-size: 16px;
  }
`

export const Price = styled.span`
  ${font('bold')};
  text-align: right;
  flex: 1;
  margin-left: 10px;
`
